import { mapKeys } from 'lodash';

const idFromName = name => name.replace(/\]/g, '').replace(/[^-a-zA-Z0-9:.]/g, '_');

const toDataAttributes = function () {
  let dataSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return mapKeys(dataSet, (value, key) => "data-".concat(key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()));
};

export { idFromName, toDataAttributes };